<template>
  <div class="flex flex-col items-center rounded-[24px] mx-5">
    <div
      class="flex flex-col w-full bg-surface"
      :class="{ 'rounded-3xl': !channelStore.isAsMonacoFanToken }"
    >
      <div
        class="bg-surface border-[3px] border-border-brand flex-col justify-start items-center inline-flex"
        :class="{ 'rounded-3xl': !channelStore.isAsMonacoFanToken }"
      >
        <!-- Header section -->
        <div
          class="p-4 bg-surface self-stretch justify-between items-start gap-3 flex flex-col lg:flex-row"
          :class="{ 'rounded-t-3xl': !channelStore.isAsMonacoFanToken }"
        >
          <div class="flex flex-row gap-3">
            <!-- Logo and community info -->
            <div
              class="self-stretch p-1.5 pb-2 bg-fill-brand-secondary rounded-full flex-col justify-between items-center inline-flex"
            >
              <Skeleton width="32px" height="32px" border-radius="50%" />
              <div class="flex-col justify-start items-center flex mt-2">
                <Skeleton width="16px" height="16px" border-radius="4px" />
              </div>
            </div>

            <!-- Prize info skeleton -->
            <div class="flex items-center gap-2">
              <Skeleton width="40px" height="40px" border-radius="8px" />
              <div class="flex flex-col gap-1">
                <Skeleton width="80px" height="12px" border-radius="4px" />
                <Skeleton width="60px" height="10px" border-radius="4px" />
              </div>
            </div>
          </div>

          <div class="flex gap-3 w-full lg:w-fit">
            <!-- Tabs skeleton -->
            <div
              class="self-stretch justify-end items-start inline-flex w-full lg:w-fit"
            >
              <div
                class="relative px-1 pt-1 flex bg-surface rounded-3xl w-full lg:w-fit h-10 border border-border-brand"
              >
                <Skeleton
                  :width="largeDesktop ? '80px' : '50%'"
                  height="32px"
                  border-radius="16px"
                />
                <Skeleton
                  :width="largeDesktop ? '80px' : '50%'"
                  height="32px"
                  border-radius="16px"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Leaderboard entries skeleton -->
        <div class="w-full px-4">
          <div class="flex flex-col gap-1.5 mb-4">
            <div
              v-for="index in 3"
              :key="index"
              class="flex items-center justify-between py-1.5"
            >
              <!-- Position -->
              <div class="flex items-center gap-3">
                <Skeleton width="28px" height="28px" border-radius="50%" />
                <!-- Avatar -->
                <Skeleton width="28px" height="28px" border-radius="50%" />
                <!-- Username -->
                <Skeleton
                  :width="usernameWidths[index % usernameWidths.length]"
                  height="16px"
                  border-radius="4px"
                />
              </div>
              <!-- Points -->
              <Skeleton
                :width="pointsWidths[index % pointsWidths.length]"
                height="16px"
                border-radius="4px"
              />
            </div>
          </div>
        </div>

        <!-- Full leaderboard button skeleton -->
        <div
          class="self-stretch p-4 pt-0 flex-col justify-start items-start gap-2.5 flex"
        >
          <Skeleton width="100%" height="40px" border-radius="20px" />
        </div>
      </div>

      <!-- Points multiplier section skeleton -->
      <div
        v-if="channelStore.isFreeMember"
        class="flex flex-col md:flex-row items-stretch md:items-center justify-center gap-3 p-4"
      >
        <div class="flex-1 flex items-center gap-2">
          <Skeleton width="48px" height="64px" border-radius="8px" />
          <div class="flex flex-col gap-2">
            <Skeleton width="150px" height="20px" border-radius="4px" />
            <Skeleton width="200px" height="16px" border-radius="4px" />
          </div>
        </div>
        <Skeleton width="150px" height="40px" border-radius="20px" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "@/components/ui/layout/skeleton.vue";
import { useChannelStore } from "@/stores/channel.store";
import { useResponsiveHelpers } from "@/composables/global/use-responsive-helpers";

const usernameWidths = ["80px", "100px", "70px", "90px", "85px"];
const pointsWidths = ["50px", "60px", "45px", "55px", "65px"];

const channelStore = useChannelStore();
const { largeDesktop } = useResponsiveHelpers();
</script>
